<template>
  <div class="right-users-table">
    <v-card>
      <v-data-table
        :headers="headers"
        :items="data ? data : []"
        :search="search"
        :loading="isLoading"
      >
        <template v-slot:top>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon color="error" @click="$emit('removeOne', item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    data: { type: Array, required: true },
    headers: { type: Array, required: true },
    isLoading: { type: Boolean, required: true }
  },
  data() {
    return {
      search: ""
    };
  },
  methods: {
    removeOne(item) {
      this.$emit("removeOne", item);
    }
  }
};
</script>